<template>
  <el-dialog
          title="流水概览详情"
          :visible.sync="dialogVisible"
          @opened="dialogOpen"
          width="90vw"
  >
    <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            size="mini"
            style="margin-bottom: -18px;"
    >

      <el-form-item
      >
        <el-date-picker
                v-model="pickerValue"
                type="daterange"
                align="right"
                size="small"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd" format="yyyy-MM-dd">
          ></el-date-picker>
      </el-form-item>

      <el-form-item
              prop="pay_type"
      >
        <el-select
                class="filter-item"
                v-model="searchForm.pay_type"
                placeholder="支付方式"
        >
          <el-option
                  v-for="item in bsOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
                type="primary"
                @click="handleSearchFormSubmit"
        >
          <d2-icon name="search" /> 查询
        </el-button>
      </el-form-item>

      <el-form-item>
        <el-button @click="handleSearchFormReset">
          <d2-icon name="refresh" /> 重置
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
            :data="tableData"
            v-loading="loading"

            size="small"
            stripe
            highlight-current-row
            style="width: 100%;"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
    >

      <el-table-column
              label="提现姓名"
      >
        <template slot-scope="scope">
          {{scope.row.drawname}}
        </template>
      </el-table-column>
      <el-table-column
              label="手机号码"
      >
        <template slot-scope="scope">
          {{scope.row.mobile_no}}
        </template>
      </el-table-column>
      <el-table-column
              label="提现时间"
      >
        <template slot-scope="scope">
          {{scope.row.pay_time2}}
        </template>
      </el-table-column>
      <el-table-column
              label="提现金额"
      >
        <template slot-scope="scope">
          {{scope.row.verifyamt}}
        </template>
      </el-table-column>

      <el-table-column
              label="支付状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state==1">
            成功
          </div>
          <div v-else-if="scope.row.state==0 || scope.row.state==3 ">
            失败：{{scope.row.return_msg}}
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="提现方式"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.df_type==2">
            微信
          </div>
          <div v-else-if="scope.row.df_type==1">
            支付宝
          </div>


        </template>
      </el-table-column>
      <el-table-column
              label="支付宝账号/微信OPENID"
              :show-overflow-tooltip="true"
              width="250"
      >
        <template slot-scope="scope">
          {{scope.row.bankaccount}}
        </template>
      </el-table-column>
      <el-table-column
              label="平台订单号"
              :show-overflow-tooltip="true"
              width="150"
      >
        <template slot-scope="scope">
          {{scope.row.id}}
        </template>
      </el-table-column>
      <el-table-column
              label="支付宝订单号/微信商户号"
              :show-overflow-tooltip="true"
              width="150"
      >
        <template slot-scope="scope">
          {{scope.row.batch_no}}
        </template>
      </el-table-column>
      <el-table-column
              label="提现来源"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.oper_type==2">
            小程序钱包提现
          </div>
          <div v-else-if="scope.row.oper_type==1">
            商家APP提现
          </div>
          <div v-else-if="scope.row.oper_type==3">
            拼团补贴提现
          </div>
        </template>
      </el-table-column>



    </el-table>
    <div style="text-align: center;margin-top: 30px;">
      <el-pagination
              :current-page="page.current"
              :page-size="page.size"
              :total="page.total"
              :page-sizes="[1,10,50,100, 200, 300, 400]"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: -10px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
    export default {
        name: "threeagentEditForm",
        props: {
            agentid: String,
            pickerValue2: String,
            pickerValue3: String,
            value: Boolean
        },
        data() {
            return {
                loading: false,
                pos:0,
                dialogVisible: false,
                tableData: [],
                pickerValue: [],
                supplierNamearr1:[],
                bsOptions: [
                    {
                        value: "1",
                        label: "支付宝"
                    },
                    {
                        value: "2",
                        label: "微信"
                    }
                ],
                searchForm: {
                  pay_type:""

                },
                page: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                sort: {
                    prop: "",
                    order: ""
                }
            };
        },
        watch: {
            value(val) {
                this.dialogVisible = val;
            },
            dialogVisible(val) {
                this.$emit("input", val);
            }
        },
        methods: {

            dateConversion(value){
                var d = new Date(value);
                //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
                var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
                console.info("===========date========="+date);
                return date;
            },
            dialogOpen() {
                this.$refs.searchForm.resetFields();
                this.pickerValue=[this.pickerValue2,this.pickerValue3];
                this.getTableData33();

            },
            getTableData33() {

                console.info("===========ddddddddd========="+this.pickerValue[0]);
                let query = {
                    pageIndex: this.page.current,
                    pageSize: this.page.size,
                    sortBy: this.sort.prop,
                    agentid: this.agentid,
                    start_time:this.pickerValue[0],
                    end_time:this.pickerValue[1],
                    descending: this.sort.order === "descending",
                    filter: this.searchForm
                };
                agentService.getTxOrderPagedlistXq(query).then(data => {
                    this.tableData = data.rows;
                    this.page.total = data.totalCount;
                    this.supplierNamesetdates(data.rows);
                });
            },
            handleSearchFormSubmit() {
                this.getTableData33();
            },
            handleSearchFormReset() {
                this.$refs.searchForm.resetFields();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSortChange(val) {
                this.sort.prop = val.prop;
                this.sort.order = val.order;
                this.getTableData33();
            },
            handleSizeChange(val) {
                this.page.size = val;
                this.getTableData33();
            },
            handleCurrentChange(val) {
                this.page.current = val;
                this.getTableData33();
            },
            close() {
                this.$refs["searchForm"].resetFields();
                this.dialogVisible = false;
            }
        }
    };
</script>
<style>
  .customWidth{
    width:90vw;
  }
</style>
